// Mock data store for CakePalace
// In production, replace with actual database calls

export interface Product {
  id: string;
  name: string;
  price: number; // GHS
  description: string;
  shortDescription: string;
  image: string;
  category: string;
  stock: number;
  featured: boolean;
  sku: string;
}

export interface CartItem {
  productId: string;
  quantity: number;
  product: Product;
}

export interface Order {
  id: string;
  orderNumber: string;
  customerName: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  location: 'accra' | 'outside';
  paymentMethod: 'pay_on_delivery' | 'mobile_money';
  transactionId?: string;
  notes?: string;
  items: CartItem[];
  subtotal: number;
  deliveryFee: number;
  total: number;
  status: 'pending' | 'confirmed' | 'preparing' | 'out_for_delivery' | 'delivered';
  createdAt: string;
  notifications: boolean;
}

export const PRODUCTS: Product[] = [
{
  id: '1',
  name: 'Nozzle Set (12pcs)',
  price: 45,
  description: 'Professional stainless steel nozzle set with 12 different tips for creating beautiful piping decorations on cakes and cupcakes. Includes star, round, petal, and leaf tips. Dishwasher safe and rust-resistant.',
  shortDescription: 'Professional 12-piece stainless steel piping nozzle set',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dcc17800-1773254105222.png",
  category: 'Decorating Tools',
  stock: 25,
  featured: true,
  sku: 'NOZ-001'
},
{
  id: '2',
  name: 'Turntable Stand',
  price: 120,
  description: 'Heavy-duty aluminum rotating cake turntable for smooth and professional cake decorating. 12-inch diameter with non-slip base. Smooth 360° rotation for perfect icing and fondant application.',
  shortDescription: 'Heavy-duty aluminum rotating cake decorating stand',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12a589e66-1773254104561.png",
  category: 'Equipment',
  stock: 12,
  featured: true,
  sku: 'TUR-001'
},
{
  id: '3',
  name: 'Fondant (1kg) - White',
  price: 85,
  description: 'Premium quality white fondant for cake covering and modeling. Smooth, pliable, and easy to work with. Can be tinted with food colors. Vanilla flavored. 1kg pack covers a standard 8-inch cake.',
  shortDescription: 'Premium white vanilla fondant, 1kg pack',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1664d486e-1773254105990.png",
  category: 'Ingredients',
  stock: 40,
  featured: true,
  sku: 'FND-001'
},
{
  id: '4',
  name: 'Dark Compound Chocolate (500g)',
  price: 65,
  description: 'High-quality dark compound chocolate for coating, ganache, and decorations. 55% cocoa content. Melts smoothly and sets with a glossy finish. No tempering required. Perfect for truffles, drip cakes, and chocolate work.',
  shortDescription: 'Premium dark compound chocolate, 500g',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1da68a582-1773334904395.png",
  category: 'Ingredients',
  stock: 30,
  featured: false,
  sku: 'CHO-001'
},
{
  id: '5',
  name: 'Piping Bags (50pcs)',
  price: 28,
  description: 'Disposable clear piping bags, 50 pieces per pack. 12-inch size fits all standard nozzles. Heavy-duty material prevents bursting. Ideal for buttercream, royal icing, and chocolate piping.',
  shortDescription: 'Disposable 12-inch piping bags, pack of 50',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15de89a28-1773254105990.png",
  category: 'Decorating Tools',
  stock: 60,
  featured: false,
  sku: 'PIP-001'
},
{
  id: '6',
  name: 'Hand Mixer (5-Speed)',
  price: 280,
  description: 'Powerful 5-speed hand mixer with turbo boost function. 250W motor for heavy batters. Includes 2 stainless steel beaters and 2 dough hooks. Ergonomic handle with easy-eject button. Perfect for cakes, meringues, and whipped cream.',
  shortDescription: '250W 5-speed electric hand mixer with attachments',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a43d5d97-1773254108320.png",
  category: 'Equipment',
  stock: 8,
  featured: true,
  sku: 'MIX-001'
},
{
  id: '7',
  name: 'Cake Tins Set (3pcs)',
  price: 95,
  description: 'Set of 3 round non-stick cake tins in sizes 6", 8", and 10". Heavy-gauge aluminum for even heat distribution. Non-stick coating for easy release. Dishwasher safe. Ideal for layered cakes and sponges.',
  shortDescription: 'Non-stick round cake tin set: 6", 8", 10"',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ee915a3-1773254108867.png",
  category: 'Bakeware',
  stock: 15,
  featured: false,
  sku: 'TIN-001'
},
{
  id: '8',
  name: 'Icing Sugar (2kg)',
  price: 35,
  description: 'Finely milled icing sugar for buttercream, royal icing, and fondant. Ultra-fine texture for smooth results. 2kg resealable bag. Sifted and ready to use. Essential for all cake decorating.',
  shortDescription: 'Ultra-fine icing sugar, 2kg resealable bag',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a2a27611-1773334904799.png",
  category: 'Ingredients',
  stock: 50,
  featured: false,
  sku: 'ICG-001'
},
{
  id: '9',
  name: 'Luster Dust / Glitter (Set of 6)',
  price: 55,
  description: 'Edible luster dust set with 6 shimmering colors: gold, silver, rose gold, bronze, pearl, and copper. Ideal for adding sparkle to fondant, chocolate, and gum paste decorations. Food-safe and certified.',
  shortDescription: 'Edible luster dust set, 6 shimmering colors',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14e620c61-1773334910236.png",
  category: 'Decorating Tools',
  stock: 20,
  featured: true,
  sku: 'LUS-001'
},
{
  id: '10',
  name: '8" Complete Cake Box',
  price: 18,
  description: 'White corrugated cake box with window and ribbon handle for 8-inch cakes. Includes matching cake board. Food-safe material. Easy assembly. Perfect for gifting and delivery.',
  shortDescription: '8-inch complete cake box with window and board',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_197322d32-1773254106124.png",
  category: 'Packaging',
  stock: 100,
  featured: false,
  sku: 'BOX-001'
},
{
  id: '11',
  name: 'Modelling Tools Set (10pcs)',
  price: 42,
  description: 'Professional fondant and sugar paste modelling tool set with 10 pieces. Includes ball tool, veining tool, shell tool, cutting wheel, and more. Durable plastic handles. Essential for sugar flowers and figurines.',
  shortDescription: '10-piece fondant modelling and sculpting tool set',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10a75a539-1773254109657.png",
  category: 'Decorating Tools',
  stock: 18,
  featured: false,
  sku: 'MOD-001'
},
{
  id: '12',
  name: 'Cupcake Paper Cases (100pcs)',
  price: 15,
  description: 'Grease-proof cupcake paper cases in mixed pastel colors. Standard muffin size, 100 pieces per pack. Made from food-grade paper. Holds shape during baking. Great for cupcakes, muffins, and mini cakes.',
  shortDescription: 'Grease-proof cupcake cases, mixed colors, 100pcs',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1deb5d346-1773254103877.png",
  category: 'Bakeware',
  stock: 0,
  featured: false,
  sku: 'CUP-001'
}];


export const CATEGORIES = ['All', 'Decorating Tools', 'Equipment', 'Ingredients', 'Bakeware', 'Packaging'];

export const getProduct = (id: string): Product | undefined => PRODUCTS.find((p) => p.id === id);

export const getStockLabel = (stock: number): {label: string;className: string;} => {
  if (stock === 0) return { label: 'Out of Stock', className: 'badge-outstock' };
  if (stock <= 5) return { label: `Only ${stock} left`, className: 'badge-lowstock' };
  return { label: 'In Stock', className: 'badge-instock' };
};

export const formatPrice = (price: number): string => `₵${price.toFixed(2)}`;